<template>
  <v-card class="card--shadow">
    <v-card-title class="purple accent-4">
      <div class="subtitle-1 white--text">Procedure Form</div>
    </v-card-title>
    <v-card-text class="pt-4">
      <form-require-noti />
      <v-row>
        <v-col lg="6">
          <label>Code <require-sign /></label>
          <v-text-field
            v-model.trim="procedure.code"
            :error-messages="handleFieldErrors($v.procedure.code)"
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col lg="6">
          <label>Name <require-sign /></label>
          <v-text-field
            v-model.trim="procedure.eng_name"
            :error-messages="handleFieldErrors($v.procedure.eng_name)"
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col lg="6">
          <label>Myanmar Name <require-sign /></label>
          <v-text-field
            v-model.trim="procedure.name"
            :error-messages="handleFieldErrors($v.procedure.name)"
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col lg="6"> </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="px-4 pb-4">
      <v-spacer></v-spacer>
      <v-btn @click.prevent="emitData" class="form-btn"> Submit </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";
import FormRequireNoti from "../notification/FormRequireNoti.vue";
import RequireSign from "@/components/notification/RequireSign.vue";

export default {
  components: { FormRequireNoti, RequireSign },
  mixins: [ValidationMixin],
  props: {
    procedure: {
      type: Object,
      default: () => {
        return {
          name: null,
          eng_name: null,
          code: null,
        };
      },
    },
  },
  data: () => ({}),
  validations: {
    procedure: {
      name: {
        required,
      },
      eng_name: {
        required,
      },
      code: {
        required,
      },
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
  },
  methods: {
    emitData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          name: this.procedure.name,
          eng_name: this.procedure.eng_name,
          code: this.procedure.code,
          description: null,
        };

        this.procedure.id ? (data.id = this.procedure.id) : false;

        this.$emit("emitData", data);

        this.procedure.name = null;
        this.procedure.eng_name = null;
        this.procedure.code = null;
        this.$v.$reset();
      }
    },
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
